"use client";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
const ContentContainer = styled(
  Box,
  {}
)(() => ({
  "&:hover": {
    cursor: "pointer"
  },
  display: "flex",
  overflow: "hidden",
  transformOrigin: "right center",
  transition: "transform 0.3s ease",
  width: "100%",
  gap: "8px"
}));
const TitleContainer = styled(
  Box,
  {}
)(() => ({
  "&:hover": {
    cursor: "pointer"
  },
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  transformOrigin: "right center",
  transition: "transform 0.3s ease",
  width: "100%"
}));
const IconContainer = styled(
  Box,
  {}
)(() => ({
  display: "flex",
  justifyContent: "center",
  minHeight: "40px",
  minWidth: "50px",
  width: "50px",
  marginTop: "8px"
}));
export {
  ContentContainer,
  IconContainer,
  TitleContainer
};
